import script from "./ShowEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowEmailModal.vue?vue&type=script&setup=true&lang=js"

import "./ShowEmailModal.vue?vue&type=style&index=0&id=8d073ce4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d073ce4"]])

export default __exports__